

import Accounts from "./Accounts";


class Element extends Accounts{
    constructor(params) {
      super(params);
    this.configuration = {children:[]};
    this.accountLabel = "Element";
    this.accountType = "Element";
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
    setVariableName(val){
      this.variableName = val;
    }
    setDisplayLabel(val){
      this.displayLabel = val;
    }
    setConfiguration(o){
      this.configuration = o;
    }
    setValue(val){
      this.value = val;
    }
    setAccesses(arr){
      this.access = arr;
    }
}

export default Element;
  